// Localized date + time formatting for orders/requests.
export const fmtDateTime = (iso, lang = "en") => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(lang, {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
